import { makeAutoObservable } from 'mobx'

export class Loader {
  loading = false

  startLoading() {
    this.loading = true
  }

  stopLoading() {
    this.loading = false
  }

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }
}
